<template>
  <div class="">
    <div class="heades bg2">
      <div class="bodyse heades_inners flex flex-col-center flex-row-between">
        <div class="flex flex-col-center">
          <img
            @click="pageChange('/')"
            class="heades_logos cur_po"
            src="@/assets/logos.png"
            alt=""
          />
          <div v-if="ispc" class="heades_lefts flex flex-col-center">
            <div
              class="heades_lefts_items cur_po"
              v-for="(item, index) in paths"
              :key="index"
            >
              <div
                :class="
                  router.currentRoute.value.meta.keys == item.key
                    ? 'heades_lefts_items_namesches'
                    : ''
                "
                class="heades_lefts_items_names flex flex-col-center flex-row-center"
                @click="pageChange(item.path)"
              >
                {{ item.text }}
              </div>
              <div class="heades_lefts_items_childrens bg5">
                <div
                  class="heades_lefts_items_childrens_names col3 cur_po"
                  v-for="(items, indexs) in item.children"
                  :key="indexs"
                  @click="pageChange(items.path)"
                >
                  {{ items.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="ispc" class="flex flex-col-center">
          <div @click="getpdfse" class="heades_rights_texts cur_po hovercolor">
            EN
          </div>
        </div>
        <div v-if="!ispc" class="flex flex-col-center">
          <img
            v-if="!showslice"
            @click="showslice = true"
            style="width: 44rem"
            src="@/assets/clices.png"
            alt=""
          />
          <el-icon v-if="showslice" @click="showslice = false" size="44rem"
            ><CircleClose
          /></el-icon>
        </div>
      </div>
    </div>
    <div class="heades_kongs"></div>

    <div v-if="showslice" class="slices flex flex-row-right">
      <div class="slices_rights relative">
        <div class="slices_inners relative">
          <div class="slices_inners_icons"></div>
          <div v-for="(item, index) in paths" :key="index">
            <div class="slices_inners_block">
              <div
                @click="sliceBtns(item, index)"
                class="slices_inners_texts flex flex-col-center flex-row-between"
              >
                <div
                  :class="[
                    item.children && index == showins ? 'col2' : '',
                    router.currentRoute.value.name == item.key ? 'col2' : '',
                  ]"
                >
                  {{ item.text }}
                </div>
                <div
                  v-if=" item.children"
                >
                  <el-icon v-if="index == showins"><ArrowUpBold /></el-icon>
                  <el-icon v-if="index != showins"><ArrowDownBold /></el-icon>
                </div>
              </div>
              <div
                v-if="index == showins && item.children"
                class="slices_inners_tables"
              >
                <div
                  class="slices_inners_titles flex flex-col-center"
                  :class="
                    router.currentRoute.value.name == items.name ? 'col2' : ''
                  "
                  v-for="(items, indexs) in item.children"
                  :key="indexs"
                  @click="pagese(items, indexs)"
                >
                  {{ items.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div @click="getpdfse" class=" heades_rights_texts">
          EN
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import routes from "@/router/routes";
import { onMounted, watch, computed, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
const { proxy } = getCurrentInstance(); //关键代码

const ispc = computed(() => store.state.ispc);
const baseUrls = computed(() => store.state.baseUrls);
const paths = computed(() => store.state.paths);
const showins = ref(-1);
const showslice = ref(false);

const getpdfse = () => {
  proxy.request("index/getpdf", {}).then((res) => {
    var urls = baseUrls.value + res.data.image;
    window.open(urls, "_blank");
  });
};

const pagese = (items, inds) => {
  showins.value = inds;
  if (!items.children) {
    pageChange(items.path);
  }
};


const sliceBtns = (items, inds) => {
  showins.value = inds;
  if (
    !items.children
  ) {
    pageChange(items.path);
  }
};

const pageChange = (urls) => {
  showslice.value = false;
  window.scrollTo(0, 0);
  router.push(urls);
};
</script>

<style>
.heades {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 400;
}
@media screen and (max-width: 768px) {
  .heades_logos {
    width: 410rem;
  }
  .heades_lefts {
    display: none;
  }
  .heades {
    box-shadow: 0rem 6rem 20rem 0rem rgba(0, 0, 0, 0.11);
  }
  .heades_inners {
    height: 130rem;
  }
  .heades_kongs {
    height: 130rem;
  }
  .lines {
    margin: 0 14rem;
  }
  .heades_rights_texts {
    font-size: 28rem;
    margin: 0 0 60rem 60rem;
  }
  .heades_rights_blocks {
    padding: 40rem ;
  }

  .slices {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 200;
    background: rgba(0, 0, 0, 0.5);
  }
  .slices_rights{
    height: 100%;
    display: flex;
	  flex-direction: column;
    overflow: hidden;
    background: #fff;
  }
  .slices_inners {
    width: 290rem;
    padding: 0 0 0 60rem;
    flex: 1;
    overflow: auto;
  }
  .slices_inners_icons {
    height: 160rem;
    position: relative;
    z-index: 9999;
  }
  .slices_inners_block {
    border-bottom: 1px solid #ebebeb;
  }
  .slices_inners_texts {
    height: 80rem;
    font-size: 28rem;
    padding-right: 40rem;
  }
  .slices_inners_tables {
    padding: 10rem 0;
  }
  .slices_inners_tables1 {
    padding: 5rem 0 5rem 20rem;
  }
  .slices_inners_titles {
    height: 58rem;
    font-size: 24rem;
  }
}
@media screen and (min-width: 768px) and (max-width: 1000px) {
  .lines {
    margin: 0 7px;
  }
  .heades_logos {
    height: 20px;
    margin-right: 5px;
  }
  .heades_kongs {
    height: 60px;
  }
  .heades_lefts_items_names {
    width: 75px;
    height: 60px;
    font-size: 14px;
  }
  .heades_lefts_items_childrens {
    top: 60px;
  }
  .heades_lefts_items_childrens_names {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
  }
  .heades_rights_texts {
    font-size: 14px;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1400px) {
  .lines {
    margin: 0 9px;
  }
  .heades_logos {
    height: 35px;
    margin-right: 7px;
  }
  .heades_kongs {
    height: 75px;
  }
  .heades_lefts_items_names {
    width: 90px;
    height: 75px;
    font-size: 14px;
  }
  .heades_lefts_items_childrens {
    top: 75px;
  }
  .heades_lefts_items_childrens_names {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
  }
  .heades_rights_texts {
    font-size: 14px;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1700px) {
  .lines {
    margin: 0 12px;
  }
  .heades_logos {
    height: 45px;
    margin-right: 10px;
  }
  .heades_kongs {
    height: 90px;
  }
  .heades_lefts_items_names {
    width: 110px;
    height: 90px;
    font-size: 16px;
  }
  .heades_lefts_items_childrens {
    top: 90px;
  }
  .heades_lefts_items_childrens_names {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
  }
  .heades_rights_texts {
    font-size: 16px;
  }
}
@media screen and (min-width: 1700px) {
  .lines {
    margin: 0 15px;
  }

  .heades_logos {
    height: 55px;
    margin-right: 10px;
  }
  .heades_kongs {
    height: 105px;
  }
  .heades_lefts_items_names {
    width: 120px;
    height: 105px;
    font-size: 18px;
  }
  .heades_lefts_items_childrens {
    top: 105px;
  }
  .heades_lefts_items_childrens_names {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    width: auto;
  }
  .heades_rights_texts {
    font-size: 16px;
  }
}

@media screen and (min-width: 768px) {
  .lines {
    width: 2px;
    height: 20px;
  }
  .heades {
    box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.11);
  }
  .heades_lefts_items {
    position: relative;
  }
  .heades_lefts_items_namesches {
    background: #e9141a;
    color: #fff;
  }
  .heades_lefts_items_childrens {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: none;
    text-align: center;
  }
  .heades_lefts_items_childrens_names {
     white-space: nowrap;
    padding: 0 10px;
    min-width: 120px;
  }


  /* .heades_lefts_items_names {
    position: relative;
  }
  .heades_lefts_items_names:before {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    height: 0;
  }
  .heades_lefts_items:hover .heades_lefts_items_names:before {
    height: 100%;
  } */


  .heades_lefts_items:hover .heades_lefts_items_names {
    background: #e9141a;
    transition: all 0.5s ease 0s;
    color: #fff;
  }
  .heades_lefts_items:hover .heades_lefts_items_childrens {
    display: block;
  }
  .heades_lefts_items_childrens_names:hover {
    background: #fff;
    color: #000;
  }
}
</style>
